import React, { useState } from "react";
import axios from "axios";
import { PiEyeLight, PiEyeSlash, PiWarningCircle } from "react-icons/pi";
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { useToast } from "../components/ToastContext";
import LoadingComp from "../components/LoadingComp";

const ResetPassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const { token } = useParams();
  const showToast = useToast() ;
  const navigate = useNavigate();
  const [reset, setReset] =useState(false) ;
  const [loading, setLoading] = useState(false) ;

  const [passWords, setpassWords] = useState({
    confirmPassword: "",
    password: "",
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setpassWords({ ...passWords, [name]: value });
  };

  if(reset) return <LoadingComp  message={'Redirecting to signin '}/>

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true)
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/students/reset-password`,
        {
          ...passWords,
        },
        {
            headers : {
            Authorization : `Bearer ${token}`
          }
        }
      );
      if(response.status===201) 
      showToast(response.data.message,'success',false, 2000); 
      setReset(true)
      setTimeout(()=>{
        navigate("/signin")
      },2000)
    } catch (err) {
      const msg =  err.response?.data?.message || err.message ||  "Error while reseting password" ;
      showToast(msg,'error',false, 2000); 
    }
  };

  return (
    <div className="mt-8 md:mx-auto md:w-full bg:none md:max-w-md sm:mx-2">
      <div className="w-[100px] m-auto mb-4">
        <img
          src="/images/logo.svg"
          alt="Aifinite Learning"
          className="w-full"
        />
      </div>
      <div
        className="bg-[#fff]
          shadow-lg rounded-md py-8 px-4 md:rounded-lg md:px-10"
        style={{
          border: "1px solid #CACFD2",
          boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
        }}
      >
        <div className="flex justify-center">
          <p className="text-2xl font-bold">Reset Your Password</p>
        </div>

        <form
          className="flex  mt-2 flex-col gap-4"
          onSubmit={handleResetPassword}
        >
          <div className="relative w-full">
            <label className="form-control">
              <span className="label"> Enter new password</span>
              <div className="relative w-full mt-2">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  required
                  value={passWords.password}
                  placeholder="Enter new password"
                  onChange={handleInput}
                  className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${
                    passWords.password.length < 8 &&
                    passWords.password.length !== 0 &&
                    "focus:ring:1 focus:ring-red-400"
                  }`}
                />
                <span
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <PiEyeSlash className="h-5 w-5" />
                  ) : (
                    <PiEyeLight className="h-5 w-5" />
                  )}
                </span>
              </div>
            </label>
          </div>

          <div className="relative w-full">
            <label className="form-control">
              <span className="label">Confirm new password</span>
              <div className="relative w-full mt-2">
                <input
                  required
                  placeholder="********"
                  onChange={handleInput}
                  type="password"
                  name="confirmPassword"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                />
                <span className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer">
                  {passWords.confirmPassword.length >=
                    passWords.password.length &&
                    passWords.password.length !== 0 && (
                      <div className="flex items-center p-2">
                        {passWords.password === passWords.confirmPassword ? (
                          <FaRegCheckCircle className="text-green-500 h-5 w-5" />
                        ) : (
                          <FaRegTimesCircle className="text-red-500 h-5 w-5" />
                        )}
                      </div>
                    )}
                </span>
              </div>
            </label>
          </div>

          {passWords.password.length < 8 && passWords.password.length !== 0 && (
            <div className="flex items-center">
              <PiWarningCircle className="text-red-500 h-5 w-5" />
              <p className="text-red-500 text-xs text-center ml-2">
                Please make sure the password is of minimum 8 characters
              </p>
            </div>
          )}

          <div className="flex justify-center mt-4">
            <button
              type="submit"
              className={`w-full bg-blue-600 text-white rounded-md py-2 tracking-[.1em] ${
                passWords.password !== passWords.confirmPassword ||
                passWords.password.length < 8 || loading
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:bg-blue-700"
              }`}
              disabled={
                passWords.password !== passWords.confirmPassword ||
                passWords.password.length < 8 || loading
              }
            >
              RESET PASSWORD
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
